import { lazy } from '../../../shared/deployment';

export const PollQuestionsetsCreate = lazy(() => import('./PollQuestionsetsCreate'));
export const PollQuestionsetsUserView = lazy(() => import('./PollQuestionsetsUserView'));
